var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1666AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83069 6.19087V7.34962H6.18694C5.84381 7.34962 5.42138 7.47 5.10694 7.69275C4.71713 7.9695 4.49944 8.38406 4.49944 9.00169C4.49944 9.61931 4.71713 10.0339 5.10694 10.3106C5.42138 10.5334 5.84381 10.6538 6.18694 10.6538H7.31194V11.8125H6.18694C5.57239 11.8064 4.97385 11.6158 4.46906 11.2652C3.77831 10.7747 3.375 10.0063 3.375 9.00169C3.375 7.99706 3.77831 7.22869 4.46906 6.73819C4.97368 6.38769 5.57201 6.197 6.18638 6.19087H8.83069ZM6.01819 9.66825V8.5095H8.83069V11.8125H7.70625V9.66825H6.01819ZM10.6875 7.34625V6.1875H14.625V11.8125H9.56137V7.35019H10.6864V10.6532H13.5V7.34681L10.6875 7.34625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbx);
export default __webpack_public_path__ + "static/media/gbx.7a8ddf7e13e8851d6168d66d9158b913.svg";
export { ForwardRef as ReactComponent };